import styled from 'styled-components';

import { media } from 'src/styles/breakpoints';
import { DateInput } from 'src/components/Toolbar';

/**
 * One control per filter, side by side, wrapping onto new rows on narrow
 * screens. Every control gets the same width so the row reads as a set.
 */
export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1.25rem;

  ${media.md} {
    gap: 0.5rem;
  }
`;

export const FilterControl = styled.div`
  flex: 1 1 12rem;
  min-width: 10rem;
  max-width: 18rem;

  ${media.md} {
    flex: 1 1 100%;
    max-width: none;
  }
`;

export const FilterLabel = styled.span`
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.midGrey};
`;

export const BarActions = styled.div`
  display: flex;
  gap: 0.5rem;
  align-self: flex-end;
  margin-left: auto;

  ${media.md} {
    margin-left: 0;
    width: 100%;
  }
`;

export const BarButton = styled.button<{ $primary?: boolean }>`
  flex: 0 0 auto;
  height: 2.5rem;
  padding: 0 0.9rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme, $primary }) => ($primary ? theme.dark : theme.grey)};
  background: ${({ theme, $primary }) => ($primary ? theme.dark : theme.background)};
  color: ${({ theme, $primary }) => ($primary ? theme.background : theme.dark)};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  ${media.md} {
    flex: 1 1 0;
  }
`;

/** The toolbar date input, stretched to fill its FilterControl like SearchInput. */
export const DateField = styled(DateInput)`
  display: block;
  width: 100%;
`;
